import { all, takeEvery, call, put } from 'redux-saga/effects';
import actions from './actions';
import Api from '../../../../helpers/api';
import { sendRequest } from '../../../../helpers/saga';
import { logger } from '../../../../helpers/logger';
import notifications from '../../../../redux/notifications/actions';
import { createSearchParams } from '../utils';

const sessionListFutureApi = new Api('orientations/future');
const groupSessionListFutureApi = new Api('orientations/:id/sessions/future');

function* loadSessionsFuture(data) {
  try {
    const { page = 1, pageSize = 10, column, order, filter } = data.payload;
    const defaultSearchParams = { page, per_page: pageSize, column, order };
    const searchParams = createSearchParams({
      defaultSearchParams,
      filter,
      tab: 'future',
    });

    const result = yield call(
      sendRequest,
      sessionListFutureApi.load,
      { search: searchParams },
      notifications.REQUEST_ERROR,
    );

    if (result.data.success) {
      const {
        data: {
          success: { data: sessions },
        },
      } = result;
      yield put(actions.loadSessionsFutureSuccess(sessions));
    }
  } catch (error) {
    logger.error(error);
  }
}

function* loadGroupSessionsFuture(data) {
  try {
    const { page = 1, pageSize = 10, column, order, filter, recurrenceSessionId } = data.payload;
    const defaultSearchParams = { page, per_page: pageSize, column, order };
    const searchParams = createSearchParams({
      defaultSearchParams,
      filter,
      tab: 'future',
    });

    const result = yield call(
      sendRequest,
      groupSessionListFutureApi.load,
      { id: recurrenceSessionId, search: searchParams },
      notifications.REQUEST_ERROR,
    );

    if (result.data.success) {
      const {
        data: {
          success: { data: sessions },
        },
      } = result;
      yield put(actions.loadGroupSessionsFutureSuccess(sessions));
    }
  } catch (error) {
    logger.error(error);
  }
}

export default function* rootSaga() {
  yield all([takeEvery(actions.LOAD_REQUEST, loadSessionsFuture)]);
  yield all([takeEvery(actions.LOAD_GROUP_REQUEST, loadGroupSessionsFuture)]);
}
